import { render, staticRenderFns } from "./ToggleItalic.vue?vue&type=template&id=5c189836&scoped=true&"
import script from "./ToggleItalic.vue?vue&type=script&lang=js&"
export * from "./ToggleItalic.vue?vue&type=script&lang=js&"
import style0 from "./ToggleItalic.vue?vue&type=style&index=0&id=5c189836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c189836",
  null
  
)

export default component.exports